export default __webpack_public_path__ + "static/media/N2P_1969.e2b9bcd5.jpg";